import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { CustomToggleButton } from 'components/ToggleButton';
import SearchSelect from 'components/SearchSelect';
import { useListConfigurations } from 'api/sdk';
import { useActivityConfiguration } from 'hooks/config/activityConfig';
import { setCurrentCameraId } from 'store/config/configSlice';
import { selectCameras } from 'store/config/configSlice';
import { useSnack } from 'plugins/snack';

interface HeaderProps {
  isAutoSave: boolean;
  setAutoSave: React.Dispatch<React.SetStateAction<boolean>>;
  currentConfigId: string;
  setCameras: React.Dispatch<any>;
  cameras: any;
}

const AnnotationHeader: React.FC<HeaderProps> = ({
  isAutoSave,
  setAutoSave,
  currentConfigId,
  setCameras,
  cameras
}) => {
  const { data: configs } = useListConfigurations();
  const snack = useSnack();
  const dispatch = useDispatch();
  const { currentCameraId } = useActivityConfiguration();
  const cameraData = useSelector(selectCameras);
  const videoData = useSelector(
    (data: any) => data?.configuration?.filteredVideo
  );

  useEffect(() => {
    if (cameraData && videoData) {
      const matchedCameras = cameraData?.filter((camData: any) =>
        videoData?.includes(camData?.id)
      );
      setCameras(matchedCameras);
    }
  }, [cameraData, videoData]);

  useEffect(() => {
    isAutoSave
      ? snack({
          message: 'Auto Save turned on successflly.',
          severity: 'success'
        })
      : snack({
          message: 'Auto Save turned off.',
          severity: 'info'
        });
  }, [isAutoSave]);

  return (
    <div className="flex w-full items-center justify-between">
      <h2 className="text-[1.1vw] font-[Proxima-Nova-Bold]">Activity Flow</h2>
      <div className="flex items-center justify-end gap-2">
        <div style={{ textAlign: 'center', display: 'flex' }}>
          <div style={{ marginRight: '10px', alignSelf: 'center' }}>
            Auto Save
          </div>
          <CustomToggleButton
            checked={isAutoSave}
            onChange={() => setAutoSave(!isAutoSave)}
          />
        </div>
        <SearchSelect
          data={[
            ...(configs?.data.map((config: any) => ({
              label: config.name,
              value: config.id
            })) || [])
          ]}
          disabled
          width="10vw"
          label="Select Configuration"
          selectValue={currentConfigId}
          placeholder="Configuration"
        />
        <SearchSelect
          label="Select Video"
          data={
            cameras
              ?.filter((data: any) => data?.video_url)
              .map((camera: any, index: number) => ({
                label: camera.name,
                value: camera.id
              })) || []
          }
          selectValue={String(currentCameraId)}
          onChange={(value: any) => {
            dispatch(setCurrentCameraId(value));
          }}
          width="10vw"
          placeholder="Video"
        />
      </div>
    </div>
  );
};

export default AnnotationHeader;
